import React from "react";
import PropTypes from "prop-types";
import { Box, LinearProgress, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export default function CapacityIndicator({
  attendeesCount,
  maxParticipants,
  capacityPercent,
  isFull,
  accentColor,
}) {
  if (maxParticipants <= 0) return null;

  return (
    <Box
      sx={{
        mt: 0.4,
        px: 1.1,
        py: 1,
        borderRadius: 1.8,
        bgcolor: alpha(accentColor, 0.07),
        border: `1px solid ${alpha(accentColor, 0.14)}`,
      }}
    >
      <LinearProgress
        variant="determinate"
        value={capacityPercent}
        color={isFull ? "error" : capacityPercent >= 80 ? "warning" : "success"}
        sx={{ borderRadius: 1, height: 7, mb: 0.5 }}
      />
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {isFull
          ? "Keine freien Plätze mehr"
          : `${attendeesCount} von ${maxParticipants} Plätzen belegt`}
      </Typography>
    </Box>
  );
}

CapacityIndicator.propTypes = {
  attendeesCount: PropTypes.number,
  maxParticipants: PropTypes.number,
  capacityPercent: PropTypes.number,
  isFull: PropTypes.bool,
  accentColor: PropTypes.string.isRequired,
};

CapacityIndicator.defaultProps = {
  attendeesCount: 0,
  maxParticipants: 0,
  capacityPercent: 0,
  isFull: false,
};
